import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { FiClipboard } from 'react-icons/fi';

import Modal from 'components/Modal';
import SolidButton from 'components/SolidButton';

const modalProps = {
  content: {
    bottom: 0,
    top: 'auto',
    transform: 'translate(-50%, 0)',
    width: '100%',
    maxWidth: 480,
    padding: '20px 16px',
    borderRadius: '12px 12px 0 0',
  },
};

const ExerciseInstructionsModal = ({ modalIsOpen, toggleModal, title, instructions }) => {
  const { t } = useTranslation();
  const pattern = /[1-9]/g;
  const formatInstructions = instructions.split(pattern).filter(Boolean);

  return (
    <Modal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      modalProps={modalProps}
      modalIsOpen={modalIsOpen}
      closeModal={toggleModal}
      closeable={false}
    >
      <section className="instructions">
        <AiOutlineCloseCircle className="instructions_closeicon" onClick={toggleModal} />
        <div className="instructions__clipboardicon">
          <FiClipboard />
        </div>
        <h2 className="instructions_title">{t('evieApp.instructionsModal.title')}</h2>
        <h3 className="instructions_subtitle">{title}</h3>
        <ol className="instructions__list">
          {formatInstructions.map((item, index) => (
            <li key={item} className="instructions__list_item">
              <strong>{index + 1}</strong>
              {item}
            </li>
          ))}
        </ol>
        <SolidButton className="evie-survey" onClick={toggleModal}>
          Ok
        </SolidButton>
      </section>
    </Modal>
  );
};

ExerciseInstructionsModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  instructions: PropTypes.string.isRequired,
};

export default ExerciseInstructionsModal;
